import { ResolverTag } from '@ps/web-core-enums';
import { Input, StarsDropDown, Toggle, Translation } from '@ps/web-shared-components';
import { StarsInfo } from '@ps/web-shared-ui';
import {
  maxLength,
  minLength,
  mustContainOnlyLatinCharacters,
  numbersOrSpace,
  required,
  zipCodeFormatCAON
} from '@ps/web-shared-validators';
import React from 'react';
import { useSelector } from 'react-redux';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import { select } from '@swf/core/store';
import { dialingCodeSelectOptions } from '@swf/core/utils/phoneVerification';
import states from '@swf/generated/states.json';

import {
  TXTCLI_Address,
  TXTCLI_City,
  TXTCLI_Country,
  TXTCLI_Country_code,
  TXTCLI_Name_person,
  TXTCLI_Phone_Number,
  TXTCLI_Zip_Post_Code,
  TXTWCL_I_confirm_that_the_information_ELL_1,
  TXTWCL_If_you_have_changed_your_nameX_ELL,
  TXTWCL_Personal_Details,
  TXTWCL_Please_enter_numbers_onlyX_1,
  TXTWCL_State___Province,
  TXTWCL_This_field_must_be_less_than_N_ELL
} from './AccountDetails.messages.json';
import styles from './AccountDetails.scss';

interface Props {
  checkboxValue: React.MutableRefObject<boolean>;
}

const AccountDetails: React.FC<Props> = ({ checkboxValue }) => {
  const country = useSelector(select.account.getCountry) as string;
  const countryStates = country && states[country];

  return (
    <>
      <br />
      <Translation tagName="b" {...TXTWCL_Personal_Details} />
      <br />
      <br />
      <StarsInfo type="info">
        <Translation
          {...TXTWCL_If_you_have_changed_your_nameX_ELL}
          values={{
            a: (msg: React.ReactNode) => (
              <ResolverLink resolverTag={ResolverTag.HelpCenter}>{msg}</ResolverLink>
            )
          }}
        />
      </StarsInfo>
      <Input id="name" disabled label={TXTCLI_Name_person} />
      <Input
        id="address"
        label={TXTCLI_Address}
        validators={[required(), minLength(4), maxLength(49), mustContainOnlyLatinCharacters()]}
      />
      <Input
        id="city"
        label={TXTCLI_City}
        validators={[required(), minLength(2), maxLength(49), mustContainOnlyLatinCharacters()]}
      />
      <Input
        id="zipCode"
        label={TXTCLI_Zip_Post_Code}
        validators={[required(), zipCodeFormatCAON()]}
      />
      {countryStates && (
        <StarsDropDown
          id="state"
          label={TXTWCL_State___Province}
          options={countryStates}
          validators={[required()]}
        />
      )}
      <Input id="country" disabled label={TXTCLI_Country} />
      <StarsDropDown
        id="countryCode"
        label={TXTCLI_Country_code}
        options={dialingCodeSelectOptions}
      />
      <Input
        id="phone"
        numericKeyboard
        label={TXTCLI_Phone_Number}
        validators={[
          required(),
          numbersOrSpace(TXTWCL_Please_enter_numbers_onlyX_1),
          maxLength(10, { ...TXTWCL_This_field_must_be_less_than_N_ELL, values: { 0: 11 } })
        ]}
      />
      <Toggle
        id="confirmCheckbox"
        data-testid="confirm-checkbox"
        className={styles.checkbox}
        type="checkbox"
        validators={[required(null)]}
        label={TXTWCL_I_confirm_that_the_information_ELL_1}
        onClick={() => (checkboxValue.current = !checkboxValue.current)}
      />
    </>
  );
};

export default AccountDetails;
